export const METADATA_WRITABLE_OUTPUT_FORMATS = ["mp3", "aac", "ogg", "flac"];

export function isMetadataWritableOutputFormat(format) {
  return METADATA_WRITABLE_OUTPUT_FORMATS.includes(format);
}

export function createEmptyMetadata() {
  return { title: "", artist: "", album: "" };
}

export function getMetadataUnsupportedMessage(format) {
  const label = format?.toUpperCase() || "この形式";
  return `${label} 形式では曲名・アーティスト名・アルバム名を埋め込めません。MP3 / AAC / OGG / FLAC 形式を選ぶと編集できます。`;
}
